<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <div class="row">
          <div class="col-12">
            <h3 class="mt-1">{{ customer.name }}</h3>
            <p class="text-black-50">
              TA {{ customer.trading_as }}
              <span v-if="customer.contact_person">
                | {{ customer.contact_person }}</span
              >
            </p>

            <h5>
              <span class="font-weight-bold">
                {{ customer.rapid_code }}
              </span>
              <span
                v-if="customer.branch"
                class="badge badge-warning float-right"
              >
                {{ customer.branch.name }}
              </span>
            </h5>

            <div class="my-3" v-if="userHasPerms(['Manage customers'])">
              <router-link
                v-b-tooltip.hover
                title="Edit"
                :to="{
                  name: 'customers-edit',
                  params: { id: customer.id },
                }"
                class="text-primary table-action-icon ml-0"
              >
                <i class="lni lni-pencil"></i>
              </router-link>

              <span
                v-b-tooltip.hover
                style="cursor: pointer"
                title="Delete"
                @click="confirmDelete(customer.id)"
                class="text-danger table-action-icon"
              >
                <i class="lni lni-trash"></i>
              </span>
            </div>
          </div>
        </div>

        <table class="table table-sm mt-2">
          <table-row label="Status">{{ customer.status }}</table-row>

          <table-row label="Rep"
            ><span v-if="customer.rep && customer.rep.user"
              >{{ customer.rep.user.name }}
            </span></table-row
          >

          <table-row label="Account Type">{{
            customer.account_type
          }}</table-row>

          <table-row label="Balance" class="font-weight-bold">{{
            customer.current_balance | currency
          }}</table-row>

          <table-row label="Credit Limit">{{
            customer.credit_limit | currency
          }}</table-row>

          <table-row label="Max Credit">{{
            customer.max_credit_limit | currency
          }}</table-row>

           <table-row label="">
             &nbsp;<br>
           </table-row>

          <table-row label="Aging Current">{{
            customer.aging_current | currency
          }}</table-row>

          <table-row label="Aging 30">{{
            customer.aging_30 | currency
          }}</table-row>

          <table-row label="Aging 60" class="text-info">{{
            customer.aging_60 | currency
          }}</table-row>

          <table-row label="Aging 90" class="text-warning">{{
            customer.aging_90 | currency
          }}</table-row>

          <table-row label="Aging 90+" class="text-danger">{{
            customer.aging_90_plus | currency
          }}</table-row>

           <table-row label="">
             &nbsp;<br>
           </table-row>

          <table-row label="Physical"
            ><a
              :href="
                'https://www.google.com/maps/search/?api=1&query=' +
                customer.physical_address
              "
              target="new"
              >{{ customer.physical_address }}
            </a>
          </table-row>

          <table-row label="Area">{{ customer.area }}</table-row>

          <table-row label="Phone"
            ><a :href="'tel:' + customer.phone_1">{{
              customer.phone_1
            }}</a></table-row
          >

          <table-row label="Phone"
            ><a :href="'tel:' + customer.phone_2">{{
              customer.phone_2
            }}</a></table-row
          >

          <table-row label="Phone"
            ><a :href="'tel:' + customer.phone_3">{{
              customer.phone_3
            }}</a></table-row
          >

          <table-row label="Email"
            ><a :href="'mailto:' + customer.email_address">{{
              customer.email_address
            }}</a></table-row
          >

          <table-row label="Notes">{{ customer.notes }}</table-row>

          <table-row icon="lni-database" :noBorder="true" />

          <table-row label="Id">{{ customer.id }} </table-row>

          <table-row label="Created"
            >{{
              moment(new Date(customer.created_at)).format(
                "DD MMM YYYY, HH:mm:ss"
              )
            }}
          </table-row>
          <table-row label="Updated"
            >{{
              moment(new Date(customer.updated_at)).format(
                "DD MMM YYYY, HH:mm:ss"
              )
            }}
          </table-row>
        </table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import customerRepo from "@/api/repos/customerRepo";
import tableRow from "@/components/common/TableRow";

export default {
  props: ["id"],

  components: {
    tableRow,
  },

  mounted() {
    this.getCustomer();
  },

  data() {
    return {
      loading: false,
      customer: {
        customer_group: {},
        supplier: {},
        brand: {},
      },
    };
  },

  methods: {
    async getCustomer() {
      try {
        this.loading = true;
        let { data } = await customerRepo.get(this.id);
        this.customer = data.customer;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async deleteCustomer(id) {
      this.isBusy = true;
      try {
        await customerRepo.delete(id);
        this.$emit("customerUpdated");
      } catch (error) {
        console.log(error);
      } finally {
        this.isBusy = false;
      }
    },
    confirmDelete(id) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete the customer.", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((confirm) => (confirm ? this.deleteCustomer(id) : false))
        .catch((error) => console.log(error));
    },
  },
};
</script>
